module.exports = __webpack_public_path__ + "img/Shape.8dec6b7a.svg";